import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogueadoComponent } from './logueado.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'logueado',
        pathMatch: 'full'
    },
    {
        path: 'logueado',
        component: LogueadoComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
            },
            {
                path: 'home',
                loadChildren: 'app/pages/logueado/home/home.module#HomeModule',
            },
            {
                path: 'tareas',
                loadChildren: 'app/pages/logueado/tareas/tareas.module#TareasModule',
            },
            {
                path: 'tarea-detalle/:id',
                redirectTo: 'tareas/tarea-detalle/:id'
            },
            {
                path: 'clientes',
                loadChildren: 'app/pages/logueado/clientes/clientes.module#ClientesModule'
            },
            {
                path: 'cotizaciones',
                loadChildren: 'app/pages/logueado/cotizaciones/cotizaciones.module#CotizacionesModule'
            },

            {
                path: 'cotizacion-detalle/:id',
                redirectTo: 'cotizaciones/cotizacion-detalle/:id'
            },
            {
                path: 'cotizacion-imprimir/:id',
                redirectTo: 'cotizaciones/cotizacion-imprimir/:id'
            },
            {
                path: 'incidencias',
                loadChildren: 'app/pages/logueado/incidencias/incidencias.module#IncidenciasModule'
            },
            {
                path: 'productos',
                loadChildren: 'app/pages/logueado/productos/productos.module#ProductosModule'
            },
            {
                path: 'prospectos',
                loadChildren: 'app/pages/logueado/prospectos/prospectos.module#ProspectosModule'
            },
            {
                path: 'usuarios',
                loadChildren: 'app/pages/logueado/usuarios/usuarios.module#UsuariosModule'
            },
            {
                path: 'galeria',
                loadChildren: 'app/pages/logueado/web/galeria/galeria.module#GaleriaModule'
            },
            {
                path: 'index',
                loadChildren: 'app/pages/logueado/web/index/index.module#IndexModule'
            },
            {
                path: 'noticias',
                loadChildren: 'app/pages/logueado/web/noticias/noticias.module#NoticiasModule'
            },
            {
                path: 'ots',
                loadChildren: 'app/pages/logueado/ots/ots.module#OtsModule'
            },
            {
                path: 'programacion',
                loadChildren: 'app/pages/logueado/programacion/programacion.module#ProgramacionModule'
            },
            {
                path: 'ordenes-venta',
                loadChildren: 'app/pages/logueado/ordenes-venta/ordenes-venta.module#OrdenesVentaModule'
            },
            {
                path: 'detalle-ov/:id',
                redirectTo: 'ordenes-venta/detalle-ov/:id'
            },
            {
                path: 'detalle-ot/:id',
                redirectTo: 'ots/detalle-ot/:id'
            },
            {
                path: 'servicios',
                loadChildren: 'app/pages/logueado/productos/productos.module#ProductosModule'
            },
            {
                path: 'personas',
                loadChildren: 'app/components/personas/personas.module#PersonasModule'
            },
            {
                path: 'propuestas',
                loadChildren: 'app/components/propuestas/propuestas.module#PropuestasModule'
            },
            {
                path: 'campana-venta',
                loadChildren: 'app/components/campana-venta/campana-venta.module#CampanaVentaModule'
            },
            {
                path: 'configuracion-empresa',
                loadChildren: 'app/components/configuracion-empresa/configuracion-empresa.module#ConfiguracionEmpresaModule'
            },
            {
                path: 'agenda',
                loadChildren: 'app/components/agenda-page/agenda-page.module#AgendaPageModule'
            },
            {
                path: 'cotizaciones-propuesta/:id',
                loadChildren: 'app/pages/logueado/cotizaciones/cotizaciones.module#CotizacionesModule'
            },
            {
                path: 'integraciones',
                loadChildren: 'app/components/integraciones/integraciones.module#IntegracionesModule'
            },
            // editar
            {
                path: 'crear-landing/:campana_venta_id/:landing_id',
                loadChildren: 'app/components/campana-venta/crear-landing/crear-landing.module#CrearLandingModule'
            },
            // crear
            {
                path: 'crear-landing/:campana_venta_id',
                loadChildren: 'app/components/campana-venta/crear-landing/crear-landing.module#CrearLandingModule'
            },
            {
                path: 'zapier',
                loadChildren: 'app/components/campana-venta/zapier/zapier.module#ZapierModule'
            },
            {
                path: 'informes',
                loadChildren: 'app/pages/logueado/informes-personalizados/informes-personalizados.module#InformesPersonalizadosModule'
            },
            {
                path: 'estados-propuesta',
                loadChildren: 'app/pages/logueado/estados-propuesta/estados-propuesta.module#EstadosPropuestaModule'
            },
            {
                path: 'contactos',
                loadChildren: 'app/pages/logueado/contactos/contactos.module#ContactosModule'
            },
            {
                path: 'workflow',
                loadChildren: 'app/pages/logueado/flujo_trabajo/flujos-trabajo.module#FlujosTrabajoModule'
            },
            {
                path: 'grupo-usuarios',
                loadChildren: 'app/pages/logueado/grupo-usuarios/grupo-usuarios.module#GrupoUsuariosModule'
            },
            {
                path: 'cursos',
                loadChildren: 'app/pages/logueado/cursos/cursos.module#CursosModule'
            },            
            {
                path: 'clasificacion-datos',
                loadChildren: 'app/pages/logueado/clasificacion-datos/clasificacion-datos.module#ClasificacionDatosModule'
            },
            {
                path: 'clasificacion-clientes',
                loadChildren: 'app/pages/logueado/clasificacion-clientes/clasificacion-clientes.module#ClasificacionClientesModule'
            },
            {
                path: 'certificaciones',
                loadChildren: 'app/pages/logueado/certificaciones/certificaciones.module#CertificacionesModule'
            },
            {
                path: 'paises',
                loadChildren: 'app/pages/logueado/paises/paises.module#PaisesModule'
            },
            {
                path: 'origen',
                loadChildren: 'app/pages/logueado/origen/origen.module#OrigenModule'
            },
            {
                path: 'examen',
                loadChildren: 'app/pages/logueado/examen/examen.module#ExamenModule'
            },
            {
                path: 'pago',
                loadChildren: 'app/pages/logueado/pago/pago.module#PagoModule'
            },
            {
                path: 'kitWeb',
                loadChildren: 'app/pages/logueado/kitWeb/kitWeb.module#KitWebModule'
            },
            {
                path: 'perfilWeb',
                loadChildren: 'app/pages/logueado/perfilWeb/perfilWeb.module#PerfilWebModule'
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LogueadoRoutingModule { }